// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-text-field__prefix[data-v-d4b75cb4]{margin-right:50px}.v-navigation-drawer[data-v-d4b75cb4]{box-shadow:none!important;height:calc(100% - 104px)!important}.v-sheet.v-card[data-v-d4b75cb4]:not(.v-sheet--outlined){box-shadow:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
